export default {
  title: 'zeroGrau',

  colors: {
    primary: '#344970',
    secondary: '#afc8db',
    tertiary: '#d5b0d3',
    text: '#A6A4A7',
    textInBg: '#fff',
    borders: '#707070',
    borderBotaoEMerkator: '#ffffff',
    boxShadow: '#000000',
  },
  transparentColors: {
    primary: 'rgba(103,169,206,0.5)',
    secondary: 'rgba(13,37,138,0.7)',
  },
};
